<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Visit Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Visit Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content">  
          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Visit Type</label
            >
            <div>
                      <MultiSelect
                        style="width: 400px"
                        v-model="selectedVisitT"
                        :options="visitTList"
                        optionLabel="name"
                        placeholder="Select Visit Type"
                        display="chip"
                        @change="visitChange()"
                      />
                    </div>
          </div>

      <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Visit Reason</label
            >
            <div v-if="reasonD == false">
              <MultiSelect
                disabled
                style="width: 400px"
                v-model="selectedVisitR"
                :options="visitRList"
                optionLabel="reason"
                placeholder="Select Visit Reason"
                display="chip"
                @change="visitReasonChange()"
              />
            </div>

             <div v-else>
              <MultiSelect
                style="width: 400px"
                v-model="selectedVisitR"
                :options="visitRList"
                optionLabel="reason"
                placeholder="Select Visit Reason"
                display="chip"
                @change="visitReasonChange()"
              />
            </div>
          </div>   
         <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>

        <div class="card p-3">
          <div class="table-responsive">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
              <div class="dataTables_filter">
                <span class="float-right">
                  <span style="margin-right: 10px"
                    ><label for="Search">Search:</label></span
                  >
                  <input
                    type="text"
                    @change="SearchDataTable()"
                    v-model="searchFilter"
                    name=""
                    id=""
                  />
                </span>
              </div>
            </div>
            <table
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="home_2"
            >
              <thead class="thead-dark">
                <tr>
                  <th style="text-align: start">
                    Visit Type<span>
                      <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Visit Reason<span>
                      <button class="asc-desc-btn" @click="orderBy(2)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Total Visits<span>
                      <button class="asc-desc-btn" @click="orderBy(3)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Total Percentage<span>
                      <button class="asc-desc-btn" @click="orderBy(4)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="vData.length == 0">
                  <td align="center" colspan="100">
                    <strong> No data available</strong>
                  </td>
                </tr>
                <tr v-for="(dat, ndx01) in vData" :key="ndx01">
                  <td>{{ dat.visitName }}</td>
                  <td>{{ dat.reasonName }}</td>
                  <td>{{ dat.totalVisits }}</td>
                  <td>{{ dat.percentage }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--show pagination-->
          <nav aria-label="Page navigation" style="float: right">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
              <!--show pagination-->
              <li v-if="showPagesMin > 1">
                <button class="page-link" @click="pageChange(1)">
                  1
                </button>
              </li>
              <li v-if="showPagesMin > 1">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <!--show pagination-->
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </span>
              </li>

              <!--show pagination-->
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button class="page-link" @click="pageChange(totalPages)">
                  {{ totalPages }}
                </button>
              </li>
              <!--show pagination-->
              <li class="page-item colorActive">
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/VisitReport";
import moment from "moment";
// import Multiselect from "@vueform/multiselect";

export default {
  name: "VisitReport",
  mixins: [localMixin],
  components: {
    //  Multiselect,
  },

  data() {
    return {
      reasonD: false,
      visitRVal: "",
      visitTypeVa: "",
      visitTList: [],
      visitType: [],
      selectedVisitT: [],

      reasonChange: false,
      visitRList: [],
      visitReason: [],
      visitReason_1: [],
      selectedVisitR: [],

      searchFilter: "",
      TimerObject: {},
      visitName: "",
      
      //Data table Stage
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      totalRows: 0,

      //show pagination
      showPagesMin: 1,
      showPagesMax: 5,
      sortColumn: 0,
      sortColumnOption: 0,

      vData: [],

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data

  methods: {}, // methods

  computed: {}, // computed

  watch: {
    visitType: function (val) {
      this.visitTList = [];
      for (let i = 0; i < val.length; i++) {
        this.visitTList.push(val[i]);
      }
    },
     visitReason: function (val) {
      this.visitRList = [];
      for (let j = 0; j < val.length; j++) {
        this.visitRList.push(val[j]);
      }
    },
  }, //watch

  mounted() {
    this.loadInit();
    this.getVisitReason();
  }, // mounted
};
</script>
<style scoped>
@import "/node_modules/vue-select-sides/styles/themes/light.scss";
.ms-container {
  background: transparent
    url("https://github.com/lou/multi-select/blob/master/img/switch.png?raw=true")
    no-repeat 50% 50%;
  /* background: transparent url('../img/switch.png') no-repeat 50% 50%; */
  width: 370px;
}
.ms-container:after {
  content: ".";
  display: block;
  height: 0;
  line-height: 0;
  font-size: 0;
  clear: both;
  min-height: 0;
  visibility: hidden;
}

.ms-container .ms-selectable,
.ms-container .ms-selection {
  background: #fff;
  color: #555555;
  float: left;
  width: 45%;
}

.ms-container .ms-selection {
  float: right;
}

.ms-container .ms-list {
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -ms-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  border: 1px solid #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  position: relative;
  height: 200px;
  padding: 0;
  overflow-y: auto;
}

.ms-container .ms-list.ms-focus {
  border-color: rgba(82, 168, 236, 0.8);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  outline: 0;
  outline: thin dotted \9;
}

.ms-container ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
}

.ms-container .ms-optgroup-container {
  width: 100%;
}

.ms-container .ms-optgroup-label {
  margin: 0;
  padding: 5px 0px 0px 5px;
  cursor: pointer;
  color: #999;
}

.ms-container .ms-selectable li.ms-elem-selectable,
.ms-container .ms-selection li.ms-elem-selection {
  border-bottom: 1px #eee solid;
  padding: 2px 10px;
  color: #555;
  font-size: 14px;
}

.ms-container .ms-selectable li.ms-hover,
.ms-container .ms-selection li.ms-hover {
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  background-color: #08c;
}

.ms-container .ms-selectable li.disabled,
.ms-container .ms-selection li.disabled {
  background-color: #eee;
  color: #aaa;
  cursor: text;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.colorActive {
  color: #f95c2e;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
</style>